// API Configuration
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api');

export const API_BASE_URL = API_URL;

const config = {
  API_BASE_URL
};

export default config;
